import { useEffect, useState } from "react";
import { api, fmtCurrency, fmtDate } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Plus, Receipt } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

const CATS = ["rent", "utilities", "stock_purchase", "salaries", "logistics", "marketing", "other"];

export default function BusinessExpenses() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ category: "rent", amount: "", note: "" });
    const refresh = () => api.get("/business/expenses").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);

    const submit = async () => {
        const a = parseFloat(form.amount);
        if (!a) return toast.error("Amount required");
        await api.post("/business/expenses", { category: form.category, amount: a, note: form.note });
        setOpen(false); setForm({ category: "rent", amount: "", note: "" }); refresh(); toast.success("Expense recorded");
    };

    return (
        <div data-testid="expenses-page">
            <MobileHeader title="Expenses" backTo="/business/more" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-3">
                <div className="bg-white rounded-2xl border border-slate-200/60 overflow-hidden product-shadow">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No expenses</div>}
                    {items.slice(0, 30).map((e, i) => (
                        <div key={e.id} className={`flex items-center gap-3 px-4 py-3.5 ${i !== items.length - 1 ? "border-b border-slate-100" : ""}`} data-testid={`expense-${e.id}`}>
                            <div className="size-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center"><Receipt size={18} /></div>
                            <div className="flex-1"><div className="font-semibold text-sm capitalize">{e.category.replace("_", " ")}</div><div className="text-xs text-slate-500">{fmtDate(e.created_at)}</div></div>
                            <div className="font-display font-bold text-sm">{fmtCurrency(e.amount)}</div>
                        </div>
                    ))}
                </div>
                <Button onClick={() => setOpen(true)} className="w-full h-12 rounded-xl bg-[#FF0055]" data-testid="add-expense-btn"><Plus size={18} /> Record Expense</Button>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="rounded-2xl">
                    <DialogHeader><DialogTitle>New Expense</DialogTitle></DialogHeader>
                    <div className="space-y-3">
                        <div>
                            <Label>Category</Label>
                            <Select value={form.category} onValueChange={(v) => setForm((f) => ({ ...f, category: v }))}>
                                <SelectTrigger className="mt-1.5 h-11 rounded-xl" data-testid="exp-cat-select"><SelectValue /></SelectTrigger>
                                <SelectContent>
                                    {CATS.map((c) => <SelectItem key={c} value={c}>{c.replace("_", " ")}</SelectItem>)}
                                </SelectContent>
                            </Select>
                        </div>
                        <div><Label>Amount (NGN)</Label><Input type="number" value={form.amount} onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="exp-amount" /></div>
                        <div><Label>Note</Label><Input value={form.note} onChange={(e) => setForm((f) => ({ ...f, note: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="exp-note" /></div>
                        <Button onClick={submit} className="w-full h-11 rounded-xl bg-[#0A1930]" data-testid="exp-submit">Save</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
